import "./ThreeByTwoLayoutComponent.scss";
import template from "./ThreeByTwoLayoutComponent.html";
import {IComponentOptions} from "angular";
import {BreakpointObserver} from "../../../../../services/breakpoints/BreakpointObserver";
import {Observable} from "rxjs";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";
import {Breakpoint} from "../../../../../services/breakpoints/Breakpoint";

export const ThreeByTwoLayout = "tfThreeByTwoLayout";

export function threeByTwoLayout(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: ThreeByTwoLayoutController
    };
}

export class ThreeByTwoLayoutController {

    public readonly widgetDisplay$: Observable<WidgetDisplayMode>;

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {
        this.widgetDisplay$ = this.buildWidgetDisplay();
    }

    private buildWidgetDisplay(): Observable<WidgetDisplayMode> {
        return this.breakpointObserver
                   .observe(Breakpoint.XL)
                   .map((bp) => bp.active)
                   .map((active) => active ? WidgetDisplayMode.WIDE : WidgetDisplayMode.TALL)
                   .publishReplay(1)
                   .refCount();
    }
}
